import * as React from 'react';
import { cn } from '../../lib/utils';

const Slider = React.forwardRef(
  (
    {
      className,
      value = [50],
      onValueChange,
      min = 0,
      max = 100,
      step = 1,
      ...props
    },
    ref
  ) => {
    const percentage = ((value[0] - min) / (max - min)) * 100;

    return (
      <div
        className={cn(
          'relative flex w-full touch-none select-none items-center',
          className
        )}
        ref={ref}
        {...props}>
        <div className="relative h-2 w-full rounded-full bg-secondary overflow-hidden">
          <div
            className="absolute h-full rounded-full"
            style={{
              width: `${percentage}%`,
              backgroundColor:
                props.style?.['--slider-color'] || 'hsl(var(--primary))'
            }}
          />
        </div>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value[0]}
          onChange={(e) => onValueChange?.([parseInt(e.target.value, 10)])}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          style={{ margin: 0 }}
        />
        <div
          className="absolute h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          style={{
            left: `calc(${percentage}% - 10px)`,
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            borderColor:
              props.style?.['--slider-color'] || 'hsl(var(--primary))'
          }}
        />
      </div>
    );
  }
);
Slider.displayName = 'Slider';

export { Slider };
